module.exports = __webpack_public_path__ + "img/WOOCOMMERCE_TEXT.7017d4ca.svg";